"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("./styles");

var _componentLoading = _interopRequireDefault(require("@doordash/component-loading"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _designLanguage = require("@doordash/design-language");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Overlay = function Overlay(_ref) {
  var isAnimated = _ref.isAnimated,
      isVisible = _ref.isVisible,
      children = _ref.children,
      type = _ref.type,
      onClick = _ref.onClick,
      content = _ref.content;

  var theme = _react["default"].useContext(_designLanguage.ThemingContext);

  return /*#__PURE__*/_react["default"].createElement(_styles.OverlayContainer, {
    onClick: isVisible ? onClick : null
  }, /*#__PURE__*/_react["default"].createElement(_styles.OverlayContent, null, children), /*#__PURE__*/_react["default"].createElement(_styles.OverlayLayer, {
    isAnimated: isAnimated,
    kind: type,
    isVisible: isVisible,
    themeColors: {
      OverlayBackgroundLoading: theme.Colors.OverlayBackgroundLoading,
      OverlayBackgroundDefault: theme.Colors.OverlayBackgroundDefault
    }
  }), isVisible && (type === _constants.Types.Loading || content) && /*#__PURE__*/_react["default"].createElement(_styles.ContentContainer, null, content || /*#__PURE__*/_react["default"].createElement(_componentLoading["default"], {
    color: theme.Colors.OverlayLoadingDefault
  })));
};

Overlay.Types = _constants.Types;
Overlay.propTypes = {
  onClick: _propTypes["default"].func,
  isAnimated: _propTypes["default"].bool.isRequired,
  isVisible: _propTypes["default"].bool.isRequired,
  children: _propTypes["default"].node,
  content: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
  type: _propTypes["default"].oneOf(Object.values(_constants.Types))
};
Overlay.defaultProps = {
  isAnimated: true,
  isVisible: false,
  type: _constants.Types.Dark
};
var _default = Overlay;
exports["default"] = _default;